// React
import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
// コンポーネント
import Profile from './Profile';
import Certifications from './Certifications';
import Projects from './Projects';
import SkillSheet from './SkillSheet';
import Works from './Works';
// スタイル
import sty from './Main.module.css';

const Main = () => {
    // 既存のステート
    const [searchParams] = useSearchParams();
    const tabParam = searchParams.get('tab');

    // タブに関する設定
    const [activeTab, setActiveTab] = useState(tabParam || 'tab1');

    const handleTabClick = (tabName) => {
        if (activeTab === tabName) return;
        const tabChangeEvent = new CustomEvent('app-tab-change');
        window.dispatchEvent(tabChangeEvent);
        
        setActiveTab(tabName);
    };

    useEffect(() => {
        if (tabParam) {
            setActiveTab(tabParam);
        }
    }, [tabParam]);

    // アクティブなタグかどうか判定
    const isActiveTab = (tabName) => {
        return activeTab === tabName ? sty['active-tab'] : '';
    };

    // 年月日選択
    const currentYear = new Date().getFullYear(); // 今年の年を取得
    const years = Array.from({ length: currentYear - (currentYear - 75) + 1 }, (_, i) => (currentYear - 75) + i); // 75歳まで選択可能
    const months = Array.from({ length: 12 }, (_, i) => i + 1); // 月の初期値を12ヶ月に設定
    const [days, setDays] = useState(Array.from({ length: 31 }, (_, i) => i + 1)); // 日付の初期値を31日に設定

    const [year, setYear] = useState(''); // 初期値は「選択」なので指定なし
    const [month, setMonth] = useState(''); // 初期値は「選択」なので指定なし
    const [day, setDay] = useState(''); // 初期値は「選択」なので指定なし

    const handleGetDays = (selectedYear, selectedMonth) => { // selectedYearとselectedMonthはフォーム入力した値(数字)
        if (selectedMonth === 2) { // 2月を選んでいる時
            if (selectedYear % 4 === 0) { // 閏年
                setDays(Array.from({ length: 29 }, (_, i) => i + 1));
            } else { // 閏年じゃない
                setDays(Array.from({ length: 28 }, (_, i) => i + 1));
            }
        } else if (selectedMonth === 4 || selectedMonth === 6 || selectedMonth === 10 || selectedMonth === 11) { // 4, 6, 10, 11月を選んでいる時は
            setDays(Array.from({ length: 30 }, (_, i) => i + 1)); // 30日まで設定
        } else {
            setDays(Array.from({ length: 31 }, (_, i) => i + 1)); // その他の月は31日にセット
        }
    };

    return (
        <div className="bg">
            <div className={sty['main-container--my-page']}>

                <div className={sty['form-tabs']}>
                    {/* タブのボタン */}
                    <div className={sty['form-tabs__tab-items']}>
                        <button onClick={() => handleTabClick('tab1')} className={`${sty['form-tabs__tab-item']} ${isActiveTab('tab1')}`}>
                            <p>PROFILE</p>
                            <p>プロフィール</p>
                        </button>

                        <button onClick={() => handleTabClick('tab2')} className={`${sty['form-tabs__tab-item']} ${isActiveTab('tab2')}`}>
                            <p>CERTIFICATIONS</p>
                            <p>保有資格</p>
                        </button>

                        <button onClick={() => handleTabClick('tab3')} className={`${sty['form-tabs__tab-item']} ${isActiveTab('tab3')}`}>
                            <p>PROJECTS</p>
                            <p>プロジェクト</p>
                        </button>

                        <button onClick={() => handleTabClick('tab4')} className={`${sty['form-tabs__tab-item']} ${isActiveTab('tab4')}`}>
                            <p>SKILL SHEET</p>
                            <p>スキルシート</p>
                        </button>

                        <button onClick={() => handleTabClick('tab5')} className={`${sty['form-tabs__tab-item']} ${isActiveTab('tab5')}`}>
                            <p>WORKS</p>
                            <p>実績</p>
                        </button>
                    </div>

                    {/* SP版 */}
                    <div className="form-tab__page-tit">
                        <div className="form-tab__page-tit-outer">
                            <p className="form-tab__page-tit-txt">
                                {activeTab === 'tab1' && 'プロフィール'}
                                {activeTab === 'tab2' && '保有資格'}
                                {activeTab === 'tab3' && 'プロジェクト'}
                                {activeTab === 'tab4' && 'スキルシート'}
                                {activeTab === 'tab5' && '実績'}
                            </p>
                            <div className="form-tab__page-tit-border"></div>
                        </div>
                    </div>

                    {/* タブの内容 */}
                    <div className={sty['form-tab__content']}>
                        {activeTab === 'tab1' && <Profile
                            years={years}
                            months={months}
                            setYear={setYear}
                            setMonth={setMonth}
                            setDay={setDay}
                            currentYear={currentYear}
                            handleGetDays={handleGetDays}
                        />}
                        {activeTab === 'tab2' && <Certifications
                            years={years}
                            months={months}
                            currentYear={currentYear}
                        />}
                        {activeTab === 'tab3' && <Projects
                            years={years}
                            months={months}
                            currentYear={currentYear}
                        />}
                        {activeTab === 'tab4' && <SkillSheet />}
                        {activeTab === 'tab5' && <Works />}
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Main;

